<div class="card">
  <div class="card-body text-center">
    @if (receivedFirstResponse) {
      @if (hasServerConnection) {
        <h3>MHNConnect has been restored</h3>
        <p class="mb-0">
          <a [routerLink]="authService.siteDownRedirect || '/login'">Click here to log back in</a>
        </p>
      } @else {
        <h3>MHNConnect is currently unavailable</h3>
        <p>
          We're temporarily offline as we perform maintenance or address an unexpected issue. Our team is working to
          restore access as quickly as possible. We appreciate your patience and apologize for the inconvenience.
        </p>
        <p>If you have any questions, please contact {{ supportPhone }}.</p>
      }
    } @else {
      <i class="fas fa-spinner fa-spin fa-3x"></i>
    }
  </div>
</div>
